export const ProjectOverview = () => {
  return (
    <div className="flex flex-col items-center justify-center"> {/* Changed justify-end to justify-center */}
      <h1 className="text-3xl font-semibold mb-4">
        Let&apos;s Think Better
      </h1>
      <p className="text-center"><em>
        Our goal is to provide you with a full range of opinions on any topic so that we may overcome limitations in our sources of information.
      </em></p>
    </div>
  );
};
